import sensors from "sa-sdk-javascript"

function createSafeEmptyObj() {
  const empty = {};
  const proxy = new Proxy(empty, {
    get(target, prop) {
      return () => proxy
    }
  });
  return proxy
}

// 初始化2个基础值
window._hmt = window._hmt || []
window.sensors = createSafeEmptyObj()

function initAnalytics() {
  console.log('initAnalytics')
  // 执行神策代码
  window.sensors = undefined
  sensors.init({
    // 数据接收地址
    server_url: `https://sensorsapi.hqchip.com/sa?project=${process.env.VUE_APP_SENSORS_PROJECT || 'default'}`,
    // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    is_track_single_page: true, 
    show_log: false,
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect'
    }
  })

  // 注册公共属性
  sensors.registerPage({
    site_domain: document.domain,
    $url_path: document.location.pathname,
    $url_host: document.location.hostname,
    $url: document.location.href,
    $referrer: document.referrer,
    $referrer_host: document.referrer&&document.referrer.match(/:\/\/(.[^/]+)/)[1]
  })

  window.sensors = sensors

  // 执行百度统计代码
  // 百度统计
  function baiduHm() {
    var hm = document.createElement("script");
    hm.src = "//hm.baidu.com/hm.js?f453ee63d802ac7fa468cd9d80eaeae5";
    hm.async = 'async';
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  }

  baiduHm()
}

// 统计代码暴露给全局
window.initAnalytics = initAnalytics